export default "__VITE_ASSET__6f1c4967__"